<!--
    描述：系统通知页面
    Created by asq
-->
<template>
	<div class="h100 register-main">
		<filter-layout @search="doSearch" @reset="resetSerach" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="100px" :model="searchForm">
					<el-form-item label="通知标题:">
						<el-input :placeholder="'请输入'" clearable size="small" v-model="searchForm.sname"> </el-input>
					</el-form-item>
					<el-form-item label="通知级别:">
						<el-select v-model="searchForm.level" placeholder="请选择..." size="small" clearable>
							<el-option v-for="item in tzjb" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布人:">
						<el-input :placeholder="'请输入'" clearable size="small" v-model="searchForm.createName"> </el-input>
					</el-form-item>
					<el-form-item label="发布时间：" prop="dateArr" class="date-width">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="content-header">
					<div class="title">
						合计系统通知：<span class="blue">{{ total }}</span> 条
					</div>
					<div class="btnGroups">
						<el-button size="mini" class="btn-success" type="success" v-if="roleBtns.includes('sysnotice-add')" @click="add"
							>新增</el-button
						>
						<el-button type="primary" class="ml5 btn-blue" size="mini" @click="reFresh">
							<i class="el-icon-refresh"></i>
						</el-button>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page">
					<div class="w-table-content" v-show="tableShow">
						<el-table ref="xTable" :data="filterData" highlight-current-row height="100%" size="mini" border>
							<el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
							<el-table-column prop="sname" label="通知标题" header-align="center" min-width="220" show-overflow-tooltip>
							</el-table-column>
							<el-table-column
								prop="applySysName"
								label="应用业务"
								align="center"
								min-width="200"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="applyNoticeName"
								label="应用对象"
								align="center"
								width="190"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="level" label="通知级别" width="90" align="center" show-overflow-tooltip>
								<template slot-scope="scope">
									<span style="color: green" v-if="scope.row.level == 1">一般</span>
									<span style="color: blue" v-else-if="scope.row.level == 2">重要</span>
									<span style="color: red" v-else-if="scope.row.level == 3">紧急</span>
								</template>
							</el-table-column>
							<el-table-column prop="createName" label="发布人" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column
								prop="createDate"
								label="发布时间"
								width="180"
								align="center"
								sortable=""
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="viewCount" label="浏览次数" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column label="状态" prop="status" width="110" align="center" show-overflow-tooltip>
								<template slot-scope="scope">
									<div class="status">
										<el-switch
											class="switch"
											v-model="scope.row.status"
											active-color="#2671cc"
											inactive-color="#ddd"
											active-text="启用"
											inactive-text="关闭"
											:active-value="1"
											:inactive-value="0"
											disabled
											:class="{
												opacityHide: !roleBtns.includes('sysnotice-enable')
											}"
											@click.native.prevent="isFlagChange(scope.row)"
										>
										</el-switch>
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" width="430">
								<template slot="header">操作 </template>
								<template slot-scope="scope">
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										v-if="scope.row.status == 0 && roleBtns.includes('sysnotice-edit')"
										@click="doEdit(scope.row, 'edit')"
									>
										<svg-icon icon-class="form-edit"></svg-icon> 编辑
									</el-button>
									<el-button
										type="primary"
										size="small"
										round
										plain
										class="table-btn"
										v-if="scope.row.status == 1 && roleBtns.includes('sysnotice-view')"
										@click="doEdit(scope.row, 'view')"
									>
										<svg-icon icon-class="form-look"></svg-icon> 查看
									</el-button>
									<el-button
										type="primary"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('sysnotice-history')"
										@click="getDetail(scope.row)"
									>
										<svg-icon icon-class="form-record"></svg-icon> 浏览记录
									</el-button>
									<el-button
										type="danger"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('sysnotice-del')"
										icon="el-icon-delete"
										:disabled="scope.row.status == 1"
										@click="delNotice(scope.row)"
										>删除</el-button
									>
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('sysnotice-top')"
										icon="el-icon-top"
										:disabled="scope.row.status !== 1"
										@click="upRow(scope.row.id, 1)"
										>置顶</el-button
									>
									<el-button
										type="warning"
										size="small"
										round
										plain
										class="table-btn"
										v-if="roleBtns.includes('sysnotice-top')"
										icon="el-icon-bottom"
										:disabled="scope.row.status !== 1 || scope.row.isTop !== 1"
										@click="upRow(scope.row.id, 0)"
										>取消置顶</el-button
									>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>
		<div class="cmain" v-if="routeQuery">
			<records-detail ref="recordsDetail" :noticeTitle="noticeTitle" :noticeId="noticeId"></records-detail>
		</div>
		<!-- 弹窗 -->
		<el-dialog
			:title="dialogObj.title"
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:fullscreen="true"
			center
			:close-on-click-modal="false"
			custom-class="h100-dialog"
			@closed="handleClose"
		>
			<el-form :model="dialogData" ref="dialogData" v-if="dialogObj.visible" :rules="formRule" :show-message="false" label-width="120px">
				<el-form-item label="名称" prop="sname">
					<el-input v-model="dialogData.sname" :disabled="disabled"> </el-input>
				</el-form-item>
				<!-- @keyup.native="dialogData.sname=dialogData.sname.replace(/[^\w\u4E00-\u9FA5]/g, '')" -->
				<el-form-item label="应用业务" prop="applySysList">
					<el-select v-model="dialogData.applySysList" :disabled="disabled" @remove-tag="roleChange" multiple>
						<el-option
							v-for="(item, index) in rangeList"
							:key="'业务' + index"
							@click.native="itmeClick(item.value)"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用对象" prop="applyRoleList">
					<el-select v-model="dialogData.applyRoleList" :disabled="disabled" multiple>
						<el-option-group v-for="group in filterRange" :key="group.label" :label="group.label">
							<el-option v-for="item in group.children" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="通知级别" prop="level">
					<el-select v-model="dialogData.level" :disabled="disabled">
						<el-option v-for="item in tzjb" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<wang-editor v-model="dialogData.content" ref="wangEditor" height="100%" :isViewMode="disabled"></wang-editor>
				</el-form-item>
				<el-form-item label="附件">
					<public-upload
						ref="zzUpload"
						:maxNum="3"
						:mode="disabled ? 'view' : ''"
						tableName="operate_sys_notice"
						:needRefresh="false"
						assortment="operateSysNotice"
						:aid="dialogData.id"
					>
					</public-upload>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" v-if="!disabled" @click="doSubmit">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { addNotice, deleteNotice, editStatus, getList, editSysNoticeTop } from '@/api/modules/notification'
import { getRange } from 'api/modules/rulesManagement'
import { mapState } from 'vuex'

import recordsDetail from './components/records-detail'

export default {
	name: 'Notification',
	components: { recordsDetail },
	data() {
		return {
			//状态选择器
			options: [
				{
					value: 1,
					label: '正常'
				},
				{
					value: 0,
					label: '停用'
				}
			],
			acceptArr: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'PNG', 'txt'],
			tzjb: [
				{
					sname: '一般',
					value: '1'
				},
				{
					sname: '重要',
					value: '2'
				},
				{
					sname: '紧急',
					value: '3'
				}
			],
			noticeTitle: '',
			noticeId: '',
			rangeList: [],

			//选中账户状态
			status2: '',
			filterData: [],
			searchForm: {
				username: '',
				sname: '',
				phone: '',
				ralName: '',
				isFlag: '',
				affiliated: '',
				startTime: '',
				endTime: ''
			},
			formRule: {
				sname: [{ required: true }],
				level: [{ required: true }],
				applyRoleList: [{ required: true, type: 'array' }],
				applySysList: [{ required: true, type: 'array' }],
				content: [{ required: true }]
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			dialogObj: {
				title: '',
				visible: false,
				width: '850px',
				mode: ''
			},
			dialogData: {
				sname: '', // 名称
				applyRole: '', // 应用对象
				applyRoleList: [], // 应用对象数组
				applySys: '', // 应用业务
				applySysList: [], // 应用业务数组
				content: '', // 内容
				mode: 'add'
			},
			searchToggle: true,
			tableShow: true,
			disabled: false
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(this.$getSessionItem('currentPage'))

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}
		this.getData()
		this.getRangeList()
	},
	methods: {
		// 应用业务 change
		itmeClick(data) {
			this.roleChange(data)
		},

		roleChange(val) {
			this.rangeList.find((y) => {
				if (y.value === val) {
					let arr = y.children
					arr.map((x) => {
						let item = this.dialogData.applyRoleList.findIndex((z) => z === x.value)
						if (item > -1) {
							this.dialogData.applyRoleList.splice(item, 1)
						}
					})
				}
			})
		},

		//重置筛选框
		resetSerach() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		//条件查询
		doSearch() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},
		// 点击新增
		add() {
			this.dialogObj.title = '新增'
			this.dialogObj.mode = 'add'
			this.dialogObj.visible = true
			this.dialogData.id = this.$SnowFlake.nextId()
		},

		// 确认添加/编辑
		doSubmit() {
			let params = Object.assign({}, this.dialogData)
			params.applyRole = params.applyRoleList.join(',')
			params.applySys = params.applySysList.join(',')
			params.newFlag = this.dialogObj.mode == 'add' ? 0 : 1
			this.$refs.dialogData.validate((valid) => {
				if (valid) {
					addNotice(params)
						.then((res) => {
							if (res.code == 0) {
								this.$message.success(res.msg)
								this.$emit('on-reset')
								this.dialogObj.visible = false
								this.getData()
							}
						})
						.catch((err) => {})
				} else {
					this.$message.warning('请填写必填项')
				}
			})
		},
		// 上传到服务器
		uploadToService(id) {
			console.log(123)
			this.$refs.zzUpload.fileSend(id)
		},

		//刷新
		reFresh() {
			this.searchForm = {}
			this.getData()
		},
		// 获取应用
		getRangeList() {
			getRange({})
				.then((res) => {
					this.rangeList = res.data
				})
				.catch((err) => {})
		},

		//获得列表数据
		getData() {
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.startDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.endDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
			}
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			getList(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
					this.dialogData = {
						sname: '',
						applyRole: '',
						applyRoleList: [],
						applySys: '',
						applySysList: [],
						content: ''
					}
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//筛选框重置
		handleClose() {
			this.dialogObj.visible = false
			this.dialogData = {
				sname: '',
				applyRole: '',
				applyRoleList: [],
				applySys: '',
				applySysList: [],
				content: ''
			}
			this.disabled = false
		},

		// 点击编辑
		doEdit(row, type) {
			let obj = Object.assign({}, row)
			obj.applyRoleList = obj.applyRole.split(',')
			obj.applySysList = obj.applySys.split(',')
			this.dialogObj.title = type === 'view' ? '查看' : '编辑'
			this.dialogObj.mode = type
			this.dialogObj.visible = true

			this.dialogData = obj
			this.dialogData.level = obj.level + ''
			// 触发applySysList 清空事件了 ，roleList 没了
			setTimeout(() => {
				this.dialogData.applyRoleList = this.dialogData.applyRole.split(',')
				// this.$refs.editor.content = obj.content
			}, 500)
			this.disabled = type == 'view'
		},

		//查看明细
		getDetail(params) {
			this.noticeId = params.id
			this.noticeTitle = params.sname
			let arr = {
				id: params.id,
				current: 1,
				size: 10,
				applyState: '1'
			}

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem('currentPage', JSON.stringify(this.currentPage))
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				name: 'Notification',
				query: {
					type: 'detail',
					id: params.id
				}
			})
		},

		//删除通知
		delNotice(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteNotice({
					id: obj.id
				}).then((d) => {
					if (d.operationCode == 1) {
						that.$message({
							message: '删除成功',
							type: 'success'
						})
						this.searchForm = {}
						this.getData()
					} else {
						this.$message.warning(d.msg)
					}
				})
			})
		},

		//修改状态
		editStatus(params) {
			this.dialogObj.visible = true
			this.dialogObj.title = '修改状态'
			this.dialogObj.width = '400px'
			this.dialogData = params
			this.dialogObj.mode = 'editStatus'
			this.status2 = params.status
		},

		// 点击置顶
		upRow(id, isTop) {
			if (!!id) {
				editSysNoticeTop({ id, isTop })
					.then((res) => {
						let msg = isTop == 1 ? '已置顶' : '取消置顶成功！'
						this.$message.success(msg)
						this.doSearch()
					})
					.catch((err) => {})
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		//改变通知状态
		isFlagChange(row) {
			if (this.roleBtns.includes('sysnotice-enable')) {
				this.$confirm('是否确认改变通知状态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						row.status == 0 ? (row.status = 1) : (row.status = 0)
						let param = { id: row.id, status: row.status }
						editStatus(param).then((res) => {
							if (res.operationCode == 1) {
								this.$message.success('修改成功')
								this.getData()
							}
						})
					})
					.catch(() => {
						this.$message.info('操作取消')
					})
			}
		}
	},
	computed: {
		...mapState('app', {
			isBack: (state) => state.isBack
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		// 应用业务
		filterRange() {
			let arr = []
			this.dialogData.applySysList.map((x) => {
				let _item = this.rangeList.find((y) => y.value === x)
				arr.push(_item)
			})
			return arr
		},
		routeQuery() {
			return this.$route.query.type
		}
	},
	watch: {
		// 监听范围的变化
		// 'dialogData.applySysList': {
		// 	handler: function(val) {
		// 		// console.log(val)
		// 		// let arr = this.dialogData.applyRoleList
		// 		// let arr2 = this.filterRange.children
		// 		// 	console.log( this.filterRange)
		// 		// let arr3 = []
		// 		// arr.map(x => {
		// 		// 	let _item = arr2.find(y => y === x)
		// 		// 	arr3.push(_item)
		// 		// })
		// 		// this.dialogData.applyRoleList = arr3
		// 		this.dialogData.applyRoleList = []
		// 	},
		// 	deep: true
		// },
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.register-main {
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}
	.blue-text:hover {
		color: blue;
	}
	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
	.content-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
			padding-left: 10px;
			border-left: 4px solid #2671cc;
			font-size: 14px;
			color: #202020;
		}
		.blue {
			font-size: 18px;
			color: #2671cc;
		}
	}
	.pd5 {
		padding: 0 5px;
	}
}
</style>

<style lang="less">
.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}
</style>
